// src/services/quizReviewService.js
import { apiRequest } from './api';

/**
 * Missed questions of the signed-in user's submitted quiz attempt.
 * Only available after submission; the server never sends the answer key.
 * @param {string} attemptId
 * @returns {Promise<{ available: boolean, missedCount: number|null, missedQuestions: Array, unavailableCount: number }>}
 */
export async function getQuizAttemptReview(attemptId) {
    return apiRequest(`/quiz/attempt/${encodeURIComponent(attemptId)}/review`, {
        authenticated: true,
    });
}
